/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MemberDataAsMember } from './MemberDataAsMember';
import {
    MemberDataAsMemberFromJSON,
    MemberDataAsMemberFromJSONTyped,
    MemberDataAsMemberToJSON,
} from './MemberDataAsMember';

/**
 * 
 * @export
 * @interface GetMemberData200Response
 */
export interface GetMemberData200Response {
    /**
     * 
     * @type {MemberDataAsMember}
     * @memberof GetMemberData200Response
     */
    data: MemberDataAsMember;
}

/**
 * Check if a given object implements the GetMemberData200Response interface.
 */
export function instanceOfGetMemberData200Response(value: object): value is GetMemberData200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetMemberData200ResponseFromJSON(json: any): GetMemberData200Response {
    return GetMemberData200ResponseFromJSONTyped(json, false);
}

export function GetMemberData200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMemberData200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': MemberDataAsMemberFromJSON(json['data']),
    };
}

export function GetMemberData200ResponseToJSON(value?: GetMemberData200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': MemberDataAsMemberToJSON(value['data']),
    };
}

